<div class="main-section tryagain-page text-center">
    <img src="https://images.5paisa.com/SPOT/activation/try-again.png" />
    <h4>Redirecting to user profile.</h4>
    <br><br>
    <h5>please wait...</h5>
</div>
    